import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLinkWithHref } from '@angular/router';

@Component({
  selector: 'ra-another-links',
  standalone: true,
  imports: [CommonModule, RouterLinkWithHref],
  templateUrl: './another-links.component.html',
  styleUrls: ['./another-links.component.scss'],
})
export class AnotherLinksComponent {
  menuState = false;

  @HostListener('mouseenter') onMouseEnter() {
    this.menuState = true;
  }
  @HostListener('mouseleave') onMouseLeave() {
    this.menuState = false;
  }
}
